import { render } from "./ScreenShare.vue?vue&type=template&id=71a9bb89&scoped=true"
import script from "./ScreenShare.vue?vue&type=script&lang=js"
export * from "./ScreenShare.vue?vue&type=script&lang=js"

import "./ScreenShare.vue?vue&type=style&index=0&id=71a9bb89&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71a9bb89"]])

export default __exports__